export function getStoredExpoPushToken(): string | null {
  if (typeof window !== 'undefined' && window.expoPushToken) {
    return window.expoPushToken;
  }

  if (typeof localStorage !== 'undefined') {
    try {
      return localStorage.getItem('expoPushToken');
    } catch {
      return null;
    }
  }

  return null;
}

export function hasStoredExpoPushToken(): boolean {
  return !!getStoredExpoPushToken();
}